export default {
  'inductiveReasoning': {
    'course-title': 'Inductive Reasoning Finding General Plural Nouns',
    'course-name': 'Section 3B-1 <span class="unit-title">Inductive Reasoning<br/>Finding General Plural Nouns<span>',
    'course-video': {
      'title': 'Section 3 SUPPORTING THE POINTS<br/>57:04 – 1’04:02 3B INDUCTIVE GROUPINGS :- ex 3B-1 finding general plural nouns+ 3B-2<br/> identifying inductive relationships+ 3B-3 distinguishing induction from deduction',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      'lecture-title': '3B-1 Lecture'
    },
    'unit-section-title': '3B-1 Exercises',
    'exercise-intro': `<p>Having thoroughly learned the intricacies of deductive reasoning, you come now to inductive reasoning. Inductive reasoning brings together three or four (never more than five) similar ideas, either to support an existing idea or to let you infer a new idea, with a structure that looks like this:</p>
    <img src="/assets/images/structure-3b1.png" alt="Original structure" />
    <p>The grouped ideas will always be able to be described by a general plural noun, such as “problems” or “changes” or “conclusions.” Generally speaking, general plural nouns fall into one of three categories – reasons, actions, or proofs – and generally answer a variation on one of three standard questions:</p>
    <ul>
    <li><u>Question</u></li>
    <li>Why?</li>
    <li>How?</li>
    <li>How do you know?</li>
    </ul>
    <ul>
    <li><u>General Plural Noun</u></li>
    <li>Reasons</li>
    <li>Steps</li>
    <li>Proofs (or deductive reasoning)</li>
    </ul>
    <p>Being able to identify the general plural noun for a grouping is essential to helping you work out the points to be included in your pyramid. If you know the idea you want to support, identifying the general plural noun for the set of ideas needed to support it signals your mind to start searching for the appropriate points of support.</p>
    <br/><p>The following set of exercises will help you think in terms of general plural nouns when reasoning inductively. Please identify the question raised by the main point, and general plural noun that describes the set of ideas that make up the answer. (I have done the first one, Bentham, to show you the pattern).</p>`,
    'menu-list': {
      'exercise-1': 'Bentham',
      'exercise-2': 'Information Systems',
      'exercise-3': 'Pensions',
      'exercise-4': 'Fifteenth Century France vs Italy',
      'exercise-5': 'The End of Classical Sculpture',
      'exercise-6': 'The Chaos Revolution',
      'exercise-7': 'The Fall of Lehman',
    },
    'exercise-1': {
      'number': '3B-1 - Exercise 1',
      'title': 'Bentham (example)',

    },
    'exercise-2': {
      'number': '3B-1 - Exercise 2',
      'title': 'Information Systems',

    },
    'exercise-3': {
      'number': '3B-1 - Exercise 3',
      'title': 'Pensions',

    },
    'exercise-4': {
      'number': '3B-1 - Exercise 4',
      'title': 'Fifteenth Century France vs Italy',

    },
    'exercise-5': {
      'number': '3B-1 - Exercise 5',
      'title': 'The End of Classical Sculpture',
    },
    'exercise-6': {
      'number': '3B-1 - Exercise 6',
      'title': 'The Chaos Revolution',
    },
    'exercise-7': {
      'number': '3B-1 - Exercise 7',
      'title': 'The Fall of Lehman',
    },
    'congratulation-message': 'THANK YOU',
    'finish-section': 'You have completed Section 3B-1',
    'final-description': 'You see that groups of inductively related ideas can be described by<br/>a general plural noun',
    'next-course-button': 'proceed to section 3B-2',
    'dashboard-button': 'Main menu',
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3b1/inductiveReasoning/i18n/en.js